import * as Sentry from '@sentry/browser'
import {
  API_CREATE_CUSTOM_AND_EXTERNAL_ACCOUNT,
  API_GET_CUSTOM_STRIPE_API_KEY,
  API_GET_CUSTOM_VERIFICATION_LINK,
  API_GET_SHOP_STRIPE_BALANCE,
  GET_PAYOUT_DETAILS
} from '../constants'
import { sendGetRequest, sendPostRequest } from './backend'
import store from '../utils/store'
import { getIdToken } from './firebase'
import { decrypt } from '../utils/encryption'

export const getStripeCustomApiKey = async () => {
  const { companyId } = store.getState().user;
  try {
    const idToken = await getIdToken();
    const headers = { Authorization: `Bearer ${idToken}` };
    const cryptedApiKEy = (
      await sendGetRequest(API_GET_CUSTOM_STRIPE_API_KEY(companyId), {}, headers)
    )?.data;
    return decrypt(cryptedApiKEy);
  } catch (error) {
    Sentry.captureMessage(`Error from ${companyId} in getting stripe custom api key: ${error}`);
  }
}

export const getStripeData = async (shopId, idToken, isAllShops) => {
  try {
    const { data: balances } = await sendPostRequest(
      API_GET_SHOP_STRIPE_BALANCE,
      {
        shopId,
        isAllShops
      },
      { Authorization: `Bearer ${idToken}` }
    );
    return balances;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in getStripeData: ${err}`);
    return false;
  }
};

export const createCustomAndExternalAccount = async (token, accountId, last4, support) => {
  const { shopId } = store.getState().user;
  const { shop = {}, generalConfig = {} } = store.getState().firebaseRealTime;
  const idToken = await getIdToken();
  const { name, legal = {} } = shop;
  const { url } = generalConfig;
  try {
    await sendPostRequest(
      API_CREATE_CUSTOM_AND_EXTERNAL_ACCOUNT,
      {
        support,
        last4,
        token,
        accountId,
        shopId,
        name,
        legal,
        url
      },
      { Authorization: `Bearer ${idToken}` }
    );
    return true;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in create custom and external account: ${err}`);
    return false;
  }
};

export const createTokens = async (stripe, name, iban) => {
  try {
    const { token: tokenIban } = await stripe.createToken(iban, {
      currency: 'eur',
      account_holder_name: name,
      account_holder_type: 'company'
    });
    const { token: tokenAccount } = await stripe.createToken('account', {
      account: {
        company: {
          name
        },
        tos_shown_and_accepted: true
      }
    });
    return { tokenIban, tokenAccount };
  } catch (err) {
    Sentry.captureMessage(`Error for ${name} in createTokens: ${err}`);
    return false;
  }
};

export const getAccountLink = async () => {
  const { user, firebaseRealTime } = store.getState();
  const { shopId } = user;
  const idToken = await getIdToken();
  const { shop } = firebaseRealTime;
  const { servicePrice } = shop;
  const { customAccountId: account } = servicePrice;
  try {
    const { data: link } = await sendPostRequest(
      API_GET_CUSTOM_VERIFICATION_LINK,
      {
        account,
        refresh_url: 'https://dashboard.dishop.co',
        return_url: 'https://dashboard.dishop.co',
        type: 'account_onboarding'
      },
      { Authorization: `Bearer ${idToken}` }
    );
    return link;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in getStripeData: ${err}`);
    return false;
  }
};
export const getStripeDetails = async (shopId, idToken, automatic, transactionId) => {
  try {
    const { data: details } = await sendPostRequest(
      GET_PAYOUT_DETAILS,
      {
        shopId, transactionId,
        automaticPayout: automatic
      },
      { Authorization: `Bearer ${idToken}` }

    );
    return details;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in getStripeDetails: ${err}`);
    return false;
  }
};